var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43488 3.35405C1.51135 2.3089 2.3816 1.5 3.42955 1.5H5.00004C5.55233 1.5 6.00004 1.94772 6.00004 2.5C6.00004 3.05228 5.55233 3.5 5.00004 3.5L3.42955 3.5L1.99738 23.073C1.95708 23.6238 1.47788 24.0376 0.927069 23.9973C0.376257 23.957 -0.0375925 23.4778 0.0027109 22.927L1.43488 3.35405ZM9.00004 2.5C9.00004 1.94772 9.44776 1.5 10 1.5H12C12.5523 1.5 13 1.94772 13 2.5C13 3.05228 12.5523 3.5 12 3.5H10C9.44776 3.5 9.00004 3.05228 9.00004 2.5ZM16 2.5C16 1.94772 16.4478 1.5 17 1.5H18.0929C19.1222 1.5 19.9835 2.28131 20.0834 3.3058L21.9953 22.9029C22.0489 23.4526 21.6468 23.9416 21.0971 23.9953C20.5475 24.0489 20.0584 23.6468 20.0048 23.0971L18.0929 3.5H17C16.4478 3.5 16 3.05228 16 2.5Z",
    fill: "#1A2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0C8.05228 0 8.5 0.447715 8.5 1V3.5C8.5 4.05228 8.05228 4.5 7.5 4.5C6.94772 4.5 6.5 4.05228 6.5 3.5V1C6.5 0.447715 6.94772 0 7.5 0ZM14.5 0C15.0523 0 15.5 0.447715 15.5 1V3.5C15.5 4.05228 15.0523 4.5 14.5 4.5C13.9477 4.5 13.5 4.05228 13.5 3.5V1C13.5 0.447715 13.9477 0 14.5 0Z",
    fill: "#1A2021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 4.8446C15.3023 4.8446 15.75 5.29232 15.75 5.8446V14.0315C16.1813 14.1425 16.5 14.534 16.5 15C16.5 15.466 16.1813 15.8575 15.75 15.9685V17.5C15.75 18.0523 15.3023 18.5 14.75 18.5C14.1977 18.5 13.75 18.0523 13.75 17.5V15.9685C13.3187 15.8575 13 15.466 13 15C13 14.534 13.3187 14.1425 13.75 14.0315V5.8446C13.75 5.29232 14.1977 4.8446 14.75 4.8446ZM7.5 4.84465C8.05228 4.84465 8.5 5.29237 8.5 5.84465V14C9.05227 14 9.49998 14.4476 9.5 14.9999C9.50002 15.5522 9.05232 15.9999 8.50003 16H8.5V16.6996C8.5 17.2519 8.05228 17.6996 7.5 17.6996C6.94772 17.6996 6.5 17.2519 6.5 16.6996V16C5.94772 16 5.5 15.5523 5.5 15C5.5 14.4477 5.94772 14 6.5 14V5.84465C6.5 5.29237 6.94772 4.84465 7.5 4.84465Z",
    fill: "#1A2021"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 18C4.5 17.4477 4.94772 17 5.5 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H5.5C4.94772 19 4.5 18.5523 4.5 18Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwing);
export default __webpack_public_path__ + "static/media/swing.69e43ee83031d21c3899652c17233bde.svg";
export { ForwardRef as ReactComponent };